var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4809 21.2794C14.0097 20.2182 12 18.4652 12 16.8078C12 14.0389 14.7501 13.0051 17 15.1441C19.2499 13.0051 22 14.0389 22 16.8078C22 18.4653 19.9903 20.2182 18.5191 21.2794C17.8531 21.7598 17.5201 22 17 22C16.4799 22 16.1469 21.7598 15.4809 21.2794Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9491 3.05039C22.2532 6.02929 21.1839 9.00969 19.0429 11.1506L17.0685 13.1251L17.103 13.1951C17.0685 13.2153 17.0342 13.2359 17 13.257C15.7857 12.5093 14.4167 12.2825 13.1632 12.7188C11.7136 13.2234 10.7737 14.4924 10.5511 16.0695L6.70612 12.2245C6.39567 11.9141 6.40032 11.4061 6.71649 11.09L7.09019 10.7163L5.84576 10.1026L4.26429 9.4367C3.97801 9.31615 3.90931 8.9423 4.13244 8.71917L6.17012 6.68149C6.94392 5.90769 8.10232 5.67442 9.09513 6.09247L9.63049 6.3179L10.8749 6.93154L12.8494 4.95706C14.9903 2.81614 17.9707 1.74685 20.9496 2.05091C21.4798 2.10502 21.895 2.52017 21.9491 3.05039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketFavourite);
export default __webpack_public_path__ + "static/media/rocket-favourite.0c1d74a3f62c3bddce873e35d41a76f5.svg";
export { ForwardRef as ReactComponent };